// ----------------------------------------------------------------------------
// Component: Blog Posts
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { A11y, Keyboard, Scrollbar } from 'swiper/modules';

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';

// Styles
// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_blog-posts.scss';

// -------------------------------------
// Variables
// -------------------------------------
var BLOG_FILTER_SELECTOR = '.carousel--blog-filters';
var BLOG_FILTER_CLASS = 'carousel--blog-filters';
var BLOG_FILTER_SECTION_SELECTOR = '.section--blog';
var BLOG_FILTER_SECTION_CLASS = 'section--blog';
var BLOG_FILTER_PAGINATION_SELECTOR = '.swiper-scrollbar';
document.querySelectorAll(BLOG_FILTER_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(BLOG_FILTER_SELECTOR).classList.add("".concat(BLOG_FILTER_CLASS, "-").concat(index));

  // Generate unique btn classes for slider arrows
  element.querySelector(BLOG_FILTER_PAGINATION_SELECTOR).classList.add("".concat(BLOG_FILTER_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(BLOG_FILTER_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [A11y, Keyboard, Scrollbar],
    slidesPerView: "auto",
    spaceBetween: 0,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    scrollbar: {
      el: "".concat(BLOG_FILTER_SECTION_SELECTOR, "-pagination-").concat(index),
      hide: false,
      draggable: true
    }
  });

  // Move to corresponding slide when Enter is pressed into pagination bullet
  // const paginationBullets = element.querySelectorAll(`${BLOG_FILTER_SECTION_SELECTOR}-pagination-${index} .swiper-pagination-bullet`);

  // paginationBullets.forEach((bullet, bulletIndex) => {
  //     bullet.addEventListener('keydown', (e) => {
  //         if (e.key === 'Enter' || e.key === ' ') {
  //         e.preventDefault(); // prevent scrolling for space
  //             swiper.slideTo(bulletIndex);
  //         }
  //     });
  // });
});